import customAxios from '../utils/customAxios';
import { useEffect, useState } from 'react';
import { GlobalVariables } from '../globalVar';

export async function fetchUserPermissions() {
  const userPermId = localStorage.getItem('userIdForPerm');
  const userToken = localStorage.getItem('token');

  if (userToken) {
    const response = await customAxios.get(`${GlobalVariables.getURL()}userPermissions/${userPermId}`, {
      headers: {
        'Authorization': 'bearer ' + localStorage.getItem('token')
      }
    });
    return response.data;
  }
  return [];
}

export function useUserPermissions(debugLabel) {
  const [userPermissions, setUserPermissions] = useState([]);

  useEffect(() => {
    fetchUserPermissions().then((permissions) => {
      if (debugLabel && localStorage.getItem('debugPermissions') === 'true') {
        console.info('[permissions-debug]', {
          screen: debugLabel,
          userIdForPerm: localStorage.getItem('userIdForPerm'),
          apiURL: GlobalVariables.getURL(),
          permissions,
          assetActions: {
            canCreate: permissions.includes('Create Asset'),
            canUpdate: permissions.includes('Update Asset'),
            canDeactivate: permissions.includes('Delete Asset'),
          },
        });
      }
      setUserPermissions(permissions);
    });
  }, [debugLabel]);

  return userPermissions;
}
